import type { ComponentPropsWithoutRef } from "react";

import { cn } from "@/lib/cn";

/**
 * 아직 안 온 내용의 자리를 잡아두는 회색 덩어리.
 *
 * 빈 화면을 먼저 보여주면 처음 온 사람은 **앱이 비었다고 오해한다.** 실제로
 * 그랬다 — 방 목록이 도착하기 전 잠깐 "아직 대화가 없어요"가 떴다.
 * 올 것이 있다는 것과 아무것도 없다는 것은 다른 말이고, 다르게 보여야 한다.
 *
 * 크기와 모서리는 **쓰는 쪽이 정한다.** 스켈레톤은 곧 올 것의 실루엣이라
 * 자기 생김새라는 게 따로 없다 — tailwind-rules §5가 막는 "생김새 덮어쓰기"의
 * 예외다. 아바타 자리에는 아바타 모서리를, 글줄 자리에는 글줄 높이를 준다.
 */
export function Skeleton({ className, ...rest }: ComponentPropsWithoutRef<"div">) {
  return (
    <div
      aria-hidden
      className={cn("animate-pulse rounded-lg bg-skeleton", className)}
      {...rest}
    />
  );
}
